import {FC} from 'react'

const SignAccordionSkeleton: FC = () => (
    <div className='signAccordion_skeleton'>
        <div className='skeleton_line' />
        <div className='skeleton_line' />
        <div className='skeleton_line short' />
    </div>
)

export default SignAccordionSkeleton
